import { render, staticRenderFns } from "./DPRSlider.vue?vue&type=template&id=9a4d410c&scoped=true"
import script from "./DPRSlider.vue?vue&type=script&lang=js"
export * from "./DPRSlider.vue?vue&type=script&lang=js"
import style0 from "./DPRSlider.vue?vue&type=style&index=0&id=9a4d410c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a4d410c",
  null
  
)

export default component.exports